import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";
import qs from "qs";

const BASE = "/accessRequests";
const serialize = (p: any) => qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listAccessRequests({ filter, includes, page, limit, select, sort }: IListParams) {
  const { data } = await api.get(BASE, {
    params: { filter, sort, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createAccessRequest({ accessRequest }: { accessRequest: any }) {
  const { data } = await api.post(BASE, { accessRequest });
  return data;
}

export async function getAccessLetterTemplate({ idSite, idActivity }: { idSite: number; idActivity: number }) {
  const { data } = await api.get(`${BASE}/letter-template`, {
    params: { idSite, idActivity },
  });
  return data; // Retorna { template: string }
}

export async function getPreviewTechnicians({ idSite, idActivity }: { idSite: number; idActivity: number }) {
  const { data } = await api.get(`${BASE}/preview-technicians`, {
    params: { idSite, idActivity },
  });
  return data; // Retorna { technicians: Array }
}

export async function deleteAccessRequest({ id }: { id: number }) {
  const { data } = await api.delete(`${BASE}/${id}`);
  return data;
}

export async function updateAccessRequest({ id, accessRequest }: { id: number; accessRequest: any }) {
  const { data } = await api.put(`${BASE}/${id}`, { accessRequest });
  return data;
}

export async function listLetterTemplates({ filter, includes, page, limit, select, sort }: IListParams) {
  const { data } = await api.get(`${BASE}/letter-templates`, {
    params: { filter, sort, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function saveLetterTemplate(templateData: any) {
  const { data } = await api.post(`${BASE}/letter-template-save`, templateData);
  return data;
}

export async function deleteLetterTemplate(id: number) {
  const { data } = await api.delete(`${BASE}/letter-template/${id}`);
  return data;
}
